(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "rxjs", "rxjs/operators"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("rxjs"), require("rxjs/operators"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.rxjs, global.rxjsOperators);
    global.disposableComponent = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _rxjs, _operators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = mountDisposableComponent;

  function mountDisposableComponent(mount, unmount) {
    return _rxjs.Observable.create(observer => {
      mount(observer.next.bind(observer), observer.complete.bind(observer), observer.error.bind(observer));
    }).pipe((0, _operators.finalize)(unmount));
  }
});
//# sourceMappingURL=rx6.js.map